/* eslint-disable header/header */
export const name = "@azure/msal-react";
export const version = "1.4.10";
